// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38930210","455":"8f58380e","977":"22bf7cc3"}[chunkId] + ".chunk.js";
};